import React from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import FightSuccess from "./FightSuccess"
import PaySuccess from "./PaySuccess"
import PaySuccessEverVault from "./PaySuccessEverVault"

import NoTicketsDownloadApp from "./NoTicketsDownloadApp"
import RemainingTickets from "./RemainingTickets"

import {
  PARKING_FLOW_TYPE,
  PAYMENT_PROVIDERS,
  REQUEST_STATUSES,
} from "~/utilities/constants"
import DesktopContainer from "~/components/DesktopContainer"
import LicensePopup from "./LicensePopup"
import Spacer from "~/components/Spacer"
import TicketLoader from "~/components/TicketLoader/TicketLoader"

const GradientBackground = styled.div`
  display: flex;
  flex-grow: 1;
  background-image: linear-gradient(
    180deg,
    ${(props) => props.theme.colors.background.main} 13%,
    ${(props) => props.theme.colors.background.page} 100%
  );
`

const GradientWrapper = ({ type, children }) => {
  if (type === PARKING_FLOW_TYPE.pay) {
    return <GradientBackground>{children}</GradientBackground>
  }
  return children
}
@inject((all) => ({
  payableSelectableCount: all.store.parkingFlow.results.payableSelectableCount,
  fightableSelectableCount:
    all.store.parkingFlow.results.fightableSelectableCount,
  type: all.store.parkingFlow.flow.type,
  ticketState: all.store.parkingFlow.flow.ticketState,
  fetchingTicketsStatus: all.store.trafficLookup.fetchingTicketsStatus,
  paymentProcessor: all.store.payment.paymentProcessor,
}))
@observer
class Success extends React.Component {
  render() {
    const {
      payableSelectableCount,
      fightableSelectableCount,
      type,
      ticketState,
    } = this.props
    const remainingTickets =
      type === PARKING_FLOW_TYPE.fight
        ? fightableSelectableCount
        : payableSelectableCount
    const alternateRemaining =
      type === PARKING_FLOW_TYPE.fight
        ? payableSelectableCount
        : fightableSelectableCount

    const showRemaining = remainingTickets || alternateRemaining || 0
    let CardContainer
    if (this.props.type === PARKING_FLOW_TYPE.pay && ticketState === "NY") {
      // Lightweight, dismissible ask for just the license ID — only when
      // the paid ticket is a NY ticket, since the lookup we seed is NY DMV only.
      CardContainer = (
        <div>
          <Spacer mobile={10} desktop={29} />
          <LicensePopup />
        </div>
      )
    }

    if (this.props.fetchingTicketsStatus === REQUEST_STATUSES.loading)
      return <TicketLoader fetcher="NY" />

    let successComponent
    if (this.props.type === PARKING_FLOW_TYPE.fight) {
      successComponent = <FightSuccess />
    } else if (this.props.paymentProcessor === PAYMENT_PROVIDERS.evervault) {
      successComponent = <PaySuccessEverVault />
    } else {
      successComponent = <PaySuccess />
      
    }

    return (
      <GradientWrapper type={this.props.type}>
        <DesktopContainer>
          {successComponent}
          <Spacer mobile={10} desktop={29} />
          {showRemaining ? <RemainingTickets /> : <NoTicketsDownloadApp />}
          {CardContainer}
        </DesktopContainer>
      </GradientWrapper>
    )
  }
}

export default Success
